<a
  class="page-link"
  [class.page-link--active]="isCurrent"
  [href]="url"
  (click)="onClick($event)"
>
  <ng-content></ng-content>
</a>
